import { atom } from "recoil";

export const getDetailCandidate = atom({
  key: "getDetailCandidateByID",
  default: [],
});

export const getOpportunityByCandidateID = atom({
  key: "getOpportunityByCandidateID",
  default: [],
});
